<template>
  <div
    :style="{ 
      backgroundImage: 'url(' + bg + ')', 
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '100vh'
    }"
  >
    <v-container fill-height>
      <v-layout 
        align-center
        fill-height 
        justify-center
      >
        <v-flex sm8 md6>
          <v-card>
            <v-layout justify-center>
              <v-flex sm10 md10>
                <v-card-title>
                  <v-layout wrap>
                    <v-flex xs6 md4>
                      <img
                        :src="logo"
                      />
                    </v-flex>
                    <v-flex xs12 class="display-1">
                      <span style="font-weight: bold;">Log In</span>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-text>
                  <v-form
                    ref="form"
                    @submit.prevent="submit"
                    lazy-validation
                    v-model="validForm"
                  >
                    
                    <v-layout row wrap>
                      
                      <v-flex xs12 class="subheading">
                        <span class="secondary--text">Enter your email and password</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Username / Email Address"
                          v-model="username"
                          :rules="usernameRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Password"
                          v-model="password"
                          :rules="passwordRules"
                          :append-icon="pw ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (pw = !pw)"
                          :type="pw ? 'password' : 'text'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn 
                          flat 
                          dark 
                          color="primary" 
                          style="margin: 0;"
                          @click="openResetPasswordDialog"
                        >Forgot password?</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap row>
                      <v-flex 
                        xs12 
                        text-sm-right
                        v-if="enableVerificationButton"
                      >
                        <v-btn
                          @click="onClickVerification"
                          color="blue"
                          depressed
                        >
                          Resend Verification
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 text-sm-right>
                        <v-btn
                          type="submit"
                          color="primary"
                          depressed
                          slot="activator"
                          :disabled="!validForm"
                        >
                          Log In
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      :color="color"
      v-model="snackbar"
    >
      {{ text }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogresetForm" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Reset Password</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <v-flex xs12>
              <v-form ref="resetPasswordForm" lazy-validation v-model="resetPasswordForm">
                <v-text-field
                  label="E-mail Address"
                  v-model="email"
                  :rules="emailRules"
                  required
                ></v-text-field>
                <v-layout>
                  <v-flex text-sm-right>
                    <v-btn
                      @click="onClickPasswordReset"
                      color="primary"
                      depressed
                      :disabled="!resetPasswordForm"
                    >
                      Send
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogResendVerification" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Resend Verification</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <v-flex xs12>
              <v-form ref="resendVerificationForm" lazy-validation v-model="resendVerificationForm">
                <v-text-field
                  label="E-mail Address"
                  v-model="email_verify"
                  :rules="emailRules"
                  required
                ></v-text-field>
                <v-layout>
                  <v-flex text-sm-right>
                    <v-btn
                      @click="onClickResendVerification"
                      color="primary"
                      depressed
                      :disabled="!resendVerificationForm"
                    >
                      {{resendVerificationForm ? 'send' : 'process...'}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>    

<script>
import axios from 'axios'
import config from '../../../configApi'
import {setAuthToken} from '@/utils/token'
const API_URL = config.apiUrl

export default {
  data () {
    return {
      pw: true,
      logo: require('@/assets/svg/Group 273.svg'),
      bg: require('@/assets/bg/access.png'),

      username: '',
      password: '',

      usernameRules: [
        v => !!v || 'Username is required.'
      ],
      passwordRules: [
        v => !!v || 'Password is required.'
      ],

      color: 'error',
      text: '',
      snackbar: false,
      validForm: true,
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      resetPasswordForm: true,
      dialogresetForm: false,
      dialogResendVerification: false,
      email: '',
      enableVerificationButton: false,
      email_verify: '',
      resendVerificationForm: true
    }
  },
  methods: {
    submit: function (e) {
      if (e.shiftKey === true) {
        this.$router.push('/dashboard')
      } else {
        if (this.$refs.form.validate()) {
          axios.post(`${API_URL}/login`, {
            email: this.username,
            password: this.password,
            remember: false
          }).then((e) => {
            // store token to session
            setAuthToken(e.data.access_token)
            // store user information
            this.setSessionUser()
          }).catch((error) => {
            if (error.response.data.error === 'invalid_authorization') {
              this.enableVerificationButton = true
            }
            this.text = error.response.data.message
            this.snackbar = true
          })
        }
      }
    },
    onClickResendVerification () {
      if (this.$refs.resendVerificationForm.validate()) {
        this.resendVerificationForm = false
        axios.post(`${API_URL}/resend/verificationToken`, {
          email: this.email_verify
        }).then((response) => {
          this.text = response.data.message
          this.snackbar = true
          this.resendVerificationForm = true
        }).catch((error) => {
          this.text = error.response.data.message
          this.snackbar = true
          this.resendVerificationForm = true
        })
      }
    },
    onClickVerification () {
      this.dialogResendVerification = true
    },
    setSessionUser () {
      axios.get(`${API_URL}/user`).then((res) => {
        localStorage.setItem('user', JSON.stringify(res.data))
        sessionStorage.setItem('user', JSON.stringify(res.data))
        this.$router.push('/dashboard')
      }).catch((error) => {
        console.log(error)
      })
    },
    openResetPasswordDialog () {
      this.dialogresetForm = true
    },
    onClickPasswordReset () {
      if (this.$refs.resetPasswordForm.validate()) {
        this.resetPasswordForm = false
        this.sendPasswordRequest()
      }
    },
    sendPasswordRequest () {
      let url = `${API_URL}/password/email`
      let data = {
        email: this.email
      }
      axios.post(url, data).then((response) => {
        this.text = 'Please check your email!'
        this.snackbar = true
        this.dialogresetForm = false
        this.resetPasswordForm = true
      }).catch((error) => {
        this.text = error.response.data.message
        this.snackbar = true
        this.resetPasswordForm = true
      })
    }
  },
  props: {
    serverData: {
      default () {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/index.vue